<div
  class="outer"
  [ngClass]="[themeClass]"
  (click)="clickSelectHandler($event)"
>
  <div
    class="insert"
    [ngClass]="{ 'insert-show': dragPosition === 'above' }"
    (dragover)="dragOverTopEdge($event)"
    (dragleave)="dragLeave($event)"
    (drop)="dragDrop($event)"
  ></div>
  <div
    #taskBox
    class="task-box hover-select-item-background display-on-hover-zone"
    [ngClass]="highlighted ? 'highlighted' : ''"
    [draggable]="!preventDragAndEdit"
    (dragstart)="dragStart($event)"
    (dragend)="dragEnd($event)"
    (dragover)="dragOver($event)"
    (dragleave)="dragLeave($event)"
    (drop)="dragDrop($event)"
  >
    <div *ngIf="orphaned && parentTasks.length" class="parent-line">
      <ng-container
        *ngFor="let parentTask of parentTasks; last as isLast; index as i"
      >
        <div class="parent-title" [ngStyle]="{ 'padding-left.px': i * 10 }">
          <span class="parent-separator">&#8735;&nbsp;</span>
          <a
            class="desktop-visible"
            [routerLink]="
              taskDetailPreservePath.split('/task/')[0] +
              '/task/' +
              parentTask._id
            "
            queryParamsHandling="merge"
            (click)="clickSelectHandler($event)"
            >{{ parentTask.title }}</a
          >
          <a
            class="mobile-visible"
            [routerLink]="['/org', orgId, 'task', parentTask._id]"
            queryParamsHandling="merge"
            (click)="clickSelectHandler($event)"
            >{{ parentTask.title }}</a
          >
        </div>
      </ng-container>
    </div>
    <div class="main-line">
      <input
        type="checkbox"
        class="task-checkbox checkbox-margin"
        [(ngModel)]="completed"
        (change)="clickCheck()"
      />

      <textarea
        #titleTextArea
        class="title-textarea"
        spellcheck="false"
        [formControl]="titleControl"
        (click)="clickSelectHandler($event)"
        (keydown)="specialKeyPressIntercept($event)"
        (focus)="onTitleTextareaFocus($event)"
        (blur)="onTitleTextareaBlur($event)"
        (mouseenter)="mouseEnter($event)"
        (mouseleave)="mouseLeave($event)"
        [readOnly]="preventDragAndEdit"
      ></textarea>

      <button
        *ngIf="inTaskDetail"
        class="desktop-visible action-button drag-button"
        aria-label="View task details"
        [routerLink]="taskDetailPreservePath"
        queryParamsHandling="merge"
      >
        <mat-icon class="display-on-hover">arrow_forward</mat-icon>
      </button>

      <button
        class="mobile-visible action-button drag-button"
        aria-label="View task details"
        [routerLink]="['/org', orgId, 'task', taskId]"
        queryParamsHandling="merge"
      >
        <mat-icon class="display-on-mobile-muted">arrow_forward</mat-icon>
      </button>

      <button
        class="action-button drag-button"
        [matMenuTriggerFor]="taskMenu"
        aria-label="Menu"
        (click)="clickSelectHandler($event)"
        (menuOpened)="suppressBlurDelete()"
      >
        <mat-icon class="display-on-hover display-on-mobile-muted"
          >menu</mat-icon
        >
      </button>

      <mat-menu #taskMenu="matMenu">
        <button
          mat-menu-item
          [routerLink]="taskDetailPreservePath"
          class="desktop-visible"
        >
          <mat-icon>article</mat-icon>
          View task details
        </button>

        <button
          mat-menu-item
          [routerLink]="['/org', orgId, 'task', taskId]"
          class="mobile-visible"
        >
          <mat-icon>article</mat-icon>
          View task details
        </button>

        <button
          mat-menu-item
          [routerLink]="['/org', orgId, 'task', taskId, 'thread']"
          class="mobile-visible"
        >
          <mat-icon>chat</mat-icon>
          View task discussion
        </button>

        <button
          mat-menu-item
          *ngIf="this.contextDepth === 0"
          (click)="sendTop()"
        >
          <mat-icon>arrow_upward</mat-icon>
          <span>Move to top of this list</span>
        </button>

        <button
          mat-menu-item
          *ngIf="!task.currentAt && !task.completedAt"
          (click)="setCurrent()"
        >
          <mat-icon>arrow_forward</mat-icon>
          <span>Set as current</span>
        </button>

        <button
          mat-menu-item
          *ngIf="task.currentAt && !task.completedAt"
          (click)="setBacklog()"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>Send to backlog</span>
        </button>

        <button mat-menu-item (click)="openInput('assignedTo')">
          <mat-icon>person</mat-icon>
          Assign to...
        </button>

        <button mat-menu-item (click)="openInput('tag')">
          <mat-icon>sell</mat-icon>
          Tags...
        </button>

        <button
          mat-menu-item
          (click)="taskService.openSchedule({ orgId, spaceId, taskId })"
        >
          <mat-icon>calendar_month</mat-icon>
          Due/Schedule...
        </button>

        <button
          *ngIf="task.completedAt"
          mat-menu-item
          (click)="taskService.changeCompletedAt({ orgId, spaceId, taskId })"
        >
          <mat-icon>update</mat-icon>
          Change time task was set as completed
        </button>

        <button
          *ngIf="task.currentAt"
          mat-menu-item
          (click)="taskService.changeCurrentAt({ orgId, spaceId, taskId })"
        >
          <mat-icon>update</mat-icon>
          Change time task was set as current
        </button>

        <button
          *ngIf="task.currentAt"
          mat-menu-item
          (click)="createChildTask()"
        >
          <mat-icon>subdirectory_arrow_right</mat-icon>
          Create child task
        </button>

        <button *ngIf="!task.trashedAt" mat-menu-item (click)="trashTask()">
          <mat-icon>delete</mat-icon>
          Trash task
        </button>

        <button
          *ngIf="task.trashedAt"
          mat-menu-item
          (click)="removeFromTrash()"
        >
          <mat-icon matListItemIcon> restore_from_trash </mat-icon>
          <span>Remove from trash</span>
        </button>

        <button
          *ngIf="task.trashedAt"
          mat-menu-item
          (click)="taskService.permanentlyDeleteTask(task)"
        >
          <mat-icon matListItemIcon> delete_forever </mat-icon>
          <span>Permanently delete task</span>
        </button>
      </mat-menu>

      <div
        class="drag-element"
        [ngClass]="{ 'drag-element-visible': dragElementVisible }"
      ></div>
    </div>

    <div
      class="bubble-line"
      *ngIf="
        children.length ||
        showStage ||
        showAssignedTo ||
        tagsDisplay.length ||
        dueText ||
        scheduleText
      "
    >
      <div
        class="subtask-button subtask-control-opacity"
        (click)="showChildren = !showChildren"
        aria-label="Show/hide subtasks"
        *ngIf="children.length"
        [ngClass]="{ 'subtask-show-children': showChildren }"
      >
        <mat-icon *ngIf="!showChildren"> chevron_right </mat-icon>
        <mat-icon *ngIf="showChildren"> expand_more </mat-icon>
        {{ children.length }}
      </div>

      <div
        class="desktop-visible message-button"
        aria-label="Messages"
        *ngIf="task.messageNumber && !inTaskDetail"
      >
        <mat-icon> chat </mat-icon>
        &nbsp;{{ task.messageNumber }}
      </div>
      <div
        class="desktop-visible message-button"
        aria-label="Messages"
        *ngIf="task.messageNumber && inTaskDetail"
        [routerLink]="taskMessagesPreservePath"
        queryParamsHandling="merge"
      >
        <mat-icon> chat </mat-icon>
        &nbsp;{{ task.messageNumber }}
      </div>
      <div
        class="mobile-visible message-button"
        aria-label="Messages"
        *ngIf="task.messageNumber"
        [routerLink]="taskMessagesPreservePath"
        queryParamsHandling="merge"
      >
        <mat-icon> chat </mat-icon>
        &nbsp;{{ task.messageNumber }}
      </div>

      <div
        *ngIf="showStage"
        class="bubble bubble-solid"
        [matMenuTriggerFor]="stageMenu"
      >
        🕗 {{ stageText }}
      </div>
      <mat-menu #stageMenu="matMenu">
        <button mat-menu-item (click)="setBacklog()">
          <mat-icon matListItemIcon>
            {{ stage === 'backlog' ? 'done' : '' }}
          </mat-icon>
          <span>Backlog</span>
        </button>
        <button mat-menu-item (click)="setCurrent()">
          <mat-icon matListItemIcon>
            {{ stage === 'current' ? 'done' : '' }}
          </mat-icon>
          <span>Current</span>
        </button>
        <button mat-menu-item (click)="setComplete()">
          <mat-icon matListItemIcon>
            {{ stage === 'complete' ? 'done' : '' }}
          </mat-icon>
          <span>Complete</span>
        </button>
      </mat-menu>
      <div
        *ngIf="showAssignedTo"
        class="bubble bubble-solid"
        (click)="openInput('assignedTo')"
      >
        {{ assignedToName ? assignedToName : 'Not assigned' }}
      </div>
      <div
        *ngFor="let tagDisplay of tagsDisplay"
        class="bubble bubble-solid"
        (click)="openInput('tag')"
      >
        {{ tagDisplay.title }}
      </div>
      <div
        *ngIf="dueText"
        class="bubble bubble-solid"
        (click)="taskService.openSchedule({ orgId, spaceId, taskId })"
      >
        Due: {{ dueText }}
      </div>
      <div
        *ngIf="scheduleText"
        class="bubble bubble-solid"
        (click)="taskService.openSchedule({ orgId, spaceId, taskId })"
      >
        <mat-icon>calendar_month</mat-icon> {{ scheduleText }}
      </div>
    </div>

    <div class="task-input">
      <app-task-input
        *ngIf="inputType"
        [orgId]="orgId"
        [spaceId]="spaceId"
        [taskId]="taskId"
        [inputType]="inputType"
        [launchSource]="inputLaunchSource"
        (returnToCursor)="returnToCursor($event)"
        (typeCharacter)="typeCharacter($event)"
        (closeInput)="closeTaskInput()"
      ></app-task-input>
    </div>
  </div>
  <div
    class="insert"
    [ngClass]="{
      'insert-show': dragPosition === 'below' || dragPosition === 'child',
      'insert-child': dragPosition === 'child'
    }"
  ></div>

  <div class="children-list" *ngIf="showChildren && children.length">
    <ng-container *ngFor="let child of children; let i = index">
      <app-task
        [listId]="listId"
        [orgId]="orgId"
        [spaceId]="spaceId"
        [taskId]="child.taskId"
        [contextDepth]="contextDepth + 1"
        [expandToContextDepth]="3"
        [inTaskDetail]="inTaskDetail"
        [siblings]="children"
        [parentTagIds]="this.task.tagIds"
        [moveCursorToDeepestChild]="
          moveCursorToDeepestChildTaskId === child.taskId
            ? { atStart: moveCursorToDeepestChildAtStart }
            : undefined
        "
        (moveCursorToPriorEmitter)="
          moveCursorToPriorChildOrHere($event.atStart, children[i - 1])
        "
        (moveCursorToNextEmitter)="
          moveCursorToNextOrParentNext($event.atStart, children[i + 1])
        "
        [preventDragAndEdit]="preventDragAndEdit"
      ></app-task>
    </ng-container>
  </div>
</div>
